module.exports = __webpack_public_path__ + "img/santiago_de_chile_toda_la_ciudad.64b12e35.jpg";